import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ApplyFormComponent } from './apply-form/apply-form.component';
import { ApplyInfoComponent } from './apply-info/apply-info.component';
import { ApplyRegulationComponent } from './apply-regulation/apply-regulation.component'; 
import { KvkkComponent } from './kvkk/kvkk.component';
import { HomeComponent } from './home/home.component';
import { ApplyResultComponent } from './apply-result/apply-result.component';   

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'basvuru-form', component: ApplyFormComponent },
  { path: 'basvuru-bilgilendirme', component: ApplyInfoComponent },
  { path: 'basvuru-yonetmelik', component: ApplyRegulationComponent }, 
  { path: 'kvkk', component: KvkkComponent },
  { path: 'sonuc', component: ApplyResultComponent },
  { path: 'anasayfa', component: HomeComponent },    
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
